import { createSlice } from '@reduxjs/toolkit';
import API from 'api/index.js';

const initialState = {
    processVehicles: [],
    isReuseCollapsed: true,
    isRecycleCollapsed: true,
};

export const operatorProcessSlice = createSlice({
    name: 'operatorProcess',
    initialState,
    reducers: {
        setIsReuseCollapsed: (state, { payload }) => { state.isReuseCollapsed = payload; },
        setIsRecycleCollapsed: (state, { payload }) => { state.isRecycleCollapsed = payload; },
    },
    extraReducers: builder => {
        const { currentShopCarStatusSearchProcess, currentShopCarSingleUpdate } = API.endpoints;

        builder
            .addMatcher(
                currentShopCarStatusSearchProcess.matchFulfilled,
                (state, { payload }) => { state.processVehicles = payload; },
            )
            .addMatcher(currentShopCarSingleUpdate.matchFulfilled, (s, { payload, meta }) => {
                const { idCar } = meta.arg.originalArgs;

                const car = s.processVehicles.find(({ id }) => id === idCar);
                if(!car) return;

                const { status } = payload;

                if(status && status !== 'shop_process') s.processVehicles.splice(s.processVehicles.indexOf(car), 1);
                else Object.assign(car, payload);
            });
    },
});

export const { setIsReuseCollapsed, setIsRecycleCollapsed } = operatorProcessSlice.actions;

export default operatorProcessSlice.reducer;
